var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 793.1 1774.5",
    style: {
      enableBackground: "new 0 0 793.1 1774.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A1D9D9;}\n\t.st1{fill:#6AC7C5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.2,610.3h-47.4c-0.1,0-0.1-0.1-0.1-0.1V0.1c0-0.1,0.1-0.1,0.1-0.1h47.4c0.1,0,0.1,0.1,0.1,0.1v610.1 C420.4,610.2,420.3,610.3,420.2,610.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M775,609.4c-25-186.7-184.9-330.7-378.5-330.7S43,422.6,18,609.4H775z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.1,828l61.2,756.8c0.4,5.2,4.7,9.2,9.9,9.2h10.9l7.8,120.7c0.3,5.1,4.5,9,9.5,9h4.1v34 c0,9.4,7.6,16.9,16.9,16.9h458.3c9.4,0,16.9-7.6,16.9-16.9v-34h4.3c5,0,9.2-4,9.5-9L664,1594h11.1c5.2,0,9.5-4,9.9-9.2L746.2,828 H47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.2,796.4c0.3,3.3,2.2,6,4.8,7.6h713.2c2.6-1.6,4.4-4.3,4.7-7.5L771,667.1H22.3L35.2,796.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M792.3,610.3H0.8c-0.6,0.5-0.9,1.3-0.7,2.1l6.1,27.8h780.6l6.1-27.8C793.2,611.6,792.9,610.8,792.3,610.3z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlush);
export default __webpack_public_path__ + "static/media/Slush.372a8ed603f3f1e572b8966b60575e67.svg";
export { ForwardRef as ReactComponent };